import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient, { isHttpError } from '../httpClient';

export const useCor = () => {
  const [cor, setCor] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchCor = async () => {
      try {
        const response = await httpClient.get(`/api/users/corpele`);

        // Transforma os dados da API para o formato esperado
        const options = response.data.map(
          (cor: { value: number; label: string }) => ({
            value: cor.value.toString(),
            label: cor.label,
          }),
        );
        setCor(options);
      } catch (error) {
        if (isHttpError(error)) {
          console.error(
            'Erro de Axios:',
            error.response?.data?.message ||
              'Erro ao buscar dados do servidor.',
          );
        } else {
          console.error('Erro inesperado ao buscar as cores de pele.', error);
        }
      }
    };

    fetchCor();
  }, []);

  return cor;
};
